import { Component, ViewEncapsulation, ViewContainerRef } from '@angular/core';
import { OffCanvasChildComponent } from '../../model/off-canvas-child-component';
import { OffCanvasComponent } from '../off-canvas.component/off-canvas.component';
import { OffCanvasService } from '../../services';

@Component({
    templateUrl: 'info-bank-information.component.html',
    styleUrls: ['info-bank-information.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class InfoBankInformationComponent extends OffCanvasChildComponent
{
    // public constructor(parent: OffCanvasComponent)
    public constructor(offCanvasService: OffCanvasService)
    {
        // super(parent);
        super(offCanvasService);
    }
}

